/* eslint-disable eqeqeq */
import { SvgIcon } from "@material-ui/core";
import moment from "moment";
import React, { useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { ReactComponent as iconPlus } from "../../../../assets/icons/icon-plus-green.svg";
import lawsuit from "../../../../assets/icons/lawsuit.svg";
import { lawsuitStatus } from "../../../../enum/LawsuitStatus";
import { USER_ROLES } from "../../../../enum/UserRoles";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "../../../../partials/datatable/Datatable";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../services/AppAPIService";
import store from "../../../../store/store";
import { formatCPF } from "../../../../utils/validators/IsValidCpfCnpj";
import Loading from "../../../home/components/Loading";
import { isXavierThemeV2Enabled } from "../../../../utils/FeatureFlags";
import StatusBadge from "../../../../components/StatusBadge";

const status = lawsuitStatus;

const LawsuitListing = (props) => {
  let api = AppAPIService.getInstance();
  const { auth } = store.getState();

  const userId = props?.userId;

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  window.setPageTitle("Listagem de Processos - Admin");

  const handleConfirmDelete = async (id) => {
    try {
      setLoading(true);
      await api.makeHttpRequest({
        method: "DELETE",
        url: `/lawsuit/${id}`,
      });

      setReload(!reload);
      setLoading(false);
      Swal.fire({
        title: "Sucesso!",
        text: "Processo deletado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao deletar processo.", "error");
    }

    setLoading(false);
  };

  const handleConfirmChangeStatus = async (obj) => {
    try {
      await api.makeHttpRequest({
        method: "PATCH",
        url: `/lawsuit/toggle/${obj.id}`,
        data: {
          active: !obj.active,
        },
      });

      setReload(!reload);

      const lawsuitStatus = !obj.active ? "ativado" : "desativado";

      Swal.fire({
        title: "Sucesso!",
        text: `Processo ${lawsuitStatus} com sucesso!`,
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao alterar status.", "error");
    }
  };

  const headRows = [
    { column: "Opções", label: "Ações", sortable: false, hideable: false },
    { column: "companyName", label: "Nome/Razão Social" },
    { column: "courtCaseNumber", label: "Nº Autos" },
    { column: "action", label: "Natureza da Ação", sortField: "action" },
    { column: "adverseParty", label: "Parte Adversa" },
    { column: "document", label: "CPF/CNPJ" },
    { column: "status", label: "Status" },
    { column: "limitDate", label: "Data limite" },
    { column: "createdAt", label: "Data Solicitação" },
  ];

  const formatRow = (r) => {
    let crudActions = ["edit"];
    if (auth?.user?.role === USER_ROLES.ADMIN) {
      crudActions.push("delete");
    }
    return (
      <StyledTableRow key={r.id} hover tabIndex={-1}>
        <StyledTableCell
          scope="row"
          style={{ padding: "0px 10px", width: "48px" }}
        >
          <CrudActions
            actions={crudActions}
            module="processo"
            onConfirmChangeStatus={handleConfirmChangeStatus}
            onConfirmDelete={handleConfirmDelete}
            id={r.id}
            obj={r}
            titleMessageDelete={""}
            addMessage={"Deseja deletar esse processo?"}
          />
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {r.companyName}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {r.courtCaseNumber && r.courtCaseNumber}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {r.action?.action}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {r.adverseParty && r.adverseParty}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {r.user?.cpfCnpj && formatCPF(r.user?.cpfCnpj)}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{
            padding: "4px 10px",
            textAlign: "left",
            minWidth: "190px",
            maxWidth: "none",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          <StatusBadge value={r.status} options={status} />
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 30 }}
        >
          {r.limitDate
            ? moment(r.limitDate).format("DD/MM/YYYY")
            : "--/--/----"}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 30 }}
        >
          {r.createdAt
            ? moment(r.createdAt).format("DD/MM/YYYY")
            : "--/--/----"}
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Datatable
        title={isXavierThemeV2Enabled() ? "Seus Processos" : "Processos"}
        hideTitle={isXavierThemeV2Enabled()}
        icon={<img src={lawsuit} alt="Adicionar" />}
        endpoint={
          userId
            ? `/lawsuit/list-paginated?userId=${userId}`
            : "/lawsuit/list-paginated"
        }
        className="bg-white xv-process-list"
        headRows={headRows}
        formatRow={formatRow}
        rows={[]}
        reload={reload}
        placeholderSearch="Busque por razão social/nome ou CPF/CNPJ"
        width={props.width}
        tooltip="Cadastrar novo processo"
        hiddenReload
        personInputs
        personStatusFilter={status}
        addButtonUrl="/admin/processo/adicionar"
        hiddenKanbanContent
        columnPreferencesKey="lawsuits"
        columnPreferencesUserId={auth?.user?.id}
        colorButton={globalColors.transparent}
        selectInput={{
          label: "Status",
          title: "Selecione um status",
          options: status,
        }}
        titleButon={
          <SvgIcon
            component={iconPlus}
            alt="Cadastrar novo processo"
            fill={globalColors.primaryColor1}
            viewBox="0 0 16 15"
            style={{
              width: "30px",
              height: "32px",
              fill: globalColors.primaryColor1,
              color: globalColors.primaryColor1,
              display:
                auth?.user?.role === USER_ROLES.ADMIN ||
                auth?.user?.role === USER_ROLES.COLLABORATOR
                  ? "block"
                  : "none",
            }}
          />
        }
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(LawsuitListing);
